import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import TabPanel from "../../core/BaseComponents/TabPanel";
import CustomizeWelcomeScreen from "../CustomizeWelcomeScreen/CustomizeWelcomeScreen";
import DefaultWelcomeScreen from "../DefaultWelcomeScreen/DefaultWelcomeScreen";
import '../RailConfiguration/RailConfig.scss';
import './WelcomeScreenConfig.scss';
import { useSelector } from "react-redux";

function WelcomeScreenConfig() {
  const [value, setValue] = useState(0);
  const [defaultConfigRevision, setDefaultConfigRevision] = useState(0);
  const { chainId } = useSelector((state) => state.chainIdReducer);

  const notifyDefaultConfigSaved = () => {
    setDefaultConfigRevision((revision) => revision + 1);
  };

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
      className: `eachtab ${value === index ? "Mui-selected" : ""}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(0);
    setDefaultConfigRevision(0);
  }, [chainId]);

  return (
    <div className="pt-2 px-3 bg-white rounded-1">
      <Box className="boxroot welcome-screen-tabs">
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              hidden: true,
              style: { transition: "none" },
            }}
          >
            <Tab label="Customize Welcome Screen" {...a11yProps(0)} />
            <Tab label="Default Welcome Screen" {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          <CustomizeWelcomeScreen
            isTabActive={value === 0}
            defaultConfigRevision={defaultConfigRevision}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <DefaultWelcomeScreen
            isTabActive={value === 1}
            onDefaultConfigSaved={notifyDefaultConfigSaved}
          />
        </TabPanel>
      </Box>
    </div>
  );
}

export default WelcomeScreenConfig;
